import QUESTION_TYPE from '@v4/constants/questions'
import FormSelectField from '@v4/components/common/Fields/FormSelectField'
import FormTextField from '@v4/components/common/Fields/FormTextField'
import FormPhoneField from '@v4/components/common/Fields/FormPhoneField'

// eslint-disable-next-line import/prefer-default-export
export const REL_KEY = {
	[QUESTION_TYPE.COUNTRY]: FormSelectField,
	[QUESTION_TYPE.INDUSTRY]: FormSelectField,
	[QUESTION_TYPE.DROPDOWN]: FormSelectField,
	[QUESTION_TYPE.TEXT]: FormTextField,
	[QUESTION_TYPE.PHONE]: FormPhoneField,
}
